import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.PowerAlert
 * The DEFA PowerAlert model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	powerconfig: '/homeAutomation/powerConfiguration?attrs=',
};

const PowerAlert = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.powerconfig + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			// Power alert
			mainsAlarmMask: null,
			mainsAlarmMaskError: null,
			/*
			 highMains : false,
			 lowMains  : false,
			 */
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	parse: function( response, options ) {
		if(response) {
			let newModelAttributes = {};
			
			if(response.mainsAlarmMask){
				this.parseAttribute('mainsAlarmMask', response.mainsAlarmMask, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'powerAlerts' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {
			mainsAlarmMask: {
				highMains: 'ON' === this.get('powerEnabled'),
				lowMains : 'ON' === this.get('powerEnabled'),
			}
		};
	},
	
	getAttributes: function() {
		return 'mainsAlarmMask';
	},
	
} );

export default PowerAlert;
